// Texts of the "activate a subscription without payment" feature (AR / EN). Kept beside the feature so the shared translation file stays untouched.
export const GRANT_TEXT = {
  ar: {
    action: "تفعيل اشتراك بدون دفع",
    title: "تفعيل اشتراك بدون دفع",
    description: "اشتراك محدود المدة يمنحه المسؤول لمتجر، دون أي فاتورة أو دفعة. تُطبَّق عليه قواعد تغطية الفروع نفسها.",
    store: "المتجر",
    selectStore: "اختر المتجر",
    plan: "الباقة",
    selectPlan: "اختر الباقة",
    branches: "الفروع المشمولة",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء (إلزامي)",
    reason: "سبب التفعيل (إلزامي)",
    review: "مراجعة",
    back: "رجوع",
    cancel: "إلغاء",
    confirmTitle: "تأكيد التفعيل بدون دفع",
    confirmBody: "سيتم تفعيل الاشتراك للفروع المحددة طوال المدة التالية دون إنشاء فاتورة أو دفعة. يتوقف تلقائيًا بعد تاريخ الانتهاء.",
    confirm: "تأكيد التفعيل",
    saving: "جارٍ التنفيذ...",
    period: "المدة",
    needAll: "اختر المتجر والباقة وفرعًا واحدًا على الأقل وتاريخي البدء والانتهاء والسبب.",
    endBeforeStart: "يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء.",
    // origin / state tags
    paid: "اشتراك مدفوع",
    granted: "ممنوح من الإدارة",
    grantedUntil: "ممنوح حتى",
    pendingStart: "ممنوح - يبدأ لاحقًا",
    expired: "منتهي",
    pendingPayment: "بانتظار الدفع",
    converted: "تحوّل إلى مدفوع",
    converting: "قيد التحويل - يُدفع قبل",
    // actions
    extend: "تمديد",
    convert: "تحويل إلى مدفوع",
    cancelGrant: "إلغاء الاشتراك الممنوح",
    extendTitle: "تمديد الاشتراك الممنوح",
    newEndDate: "تاريخ الانتهاء الجديد",
    convertTitle: "تحويل إلى اشتراك مدفوع",
    convertBody: "يبقى الاشتراك نفسه ويبقى تاريخ انتهاء المنحة هو آخر موعد للتغطية المجانية، وتصدر فاتورة غير مدفوعة. عند اعتماد الدفعة قبل الموعد تبدأ التغطية المدفوعة، وإلا تنتهي التغطية في الموعد. لا تُسجَّل أي دفعة.",
    cancelTitle: "إلغاء الاشتراك الممنوح",
    cancelBody: "تتوقف التغطية فورًا. لا يمكن التراجع عن الإلغاء.",
    actionReason: "السبب (إلزامي)",
    done: "تم",
  },
  en: {
    action: "Activate subscription without payment",
    title: "Activate subscription without payment",
    description: "A time-limited subscription an administrator grants to a store, with no invoice or payment. The same branch coverage rules apply.",
    store: "Store",
    selectStore: "Select a store",
    plan: "Plan",
    selectPlan: "Select a plan",
    branches: "Covered branches",
    startDate: "Start date",
    endDate: "End date (required)",
    reason: "Reason for activation (required)",
    review: "Review",
    back: "Back",
    cancel: "Cancel",
    confirmTitle: "Confirm activation without payment",
    confirmBody: "The subscription will be active for the selected branches for the period below with no invoice and no payment. It stops by itself after the end date.",
    confirm: "Confirm activation",
    saving: "Working...",
    period: "Period",
    needAll: "Select the store, the plan, at least one branch, both dates and a reason.",
    endBeforeStart: "The end date must be after the start date.",
    paid: "Paid subscription",
    granted: "Admin-granted",
    grantedUntil: "Granted until",
    pendingStart: "Granted - starts later",
    expired: "Expired",
    pendingPayment: "Pending payment",
    converted: "Converted to paid",
    converting: "Converting - pay before",
    extend: "Extend",
    convert: "Convert to paid",
    cancelGrant: "Cancel granted subscription",
    extendTitle: "Extend granted subscription",
    newEndDate: "New end date",
    convertTitle: "Convert to a paid subscription",
    convertBody: "The same subscription continues and the grant's end date stays the last day of free coverage; an unpaid invoice is issued. When a payment is approved before that date paid coverage starts, otherwise coverage ends on that date. No payment is recorded.",
    cancelTitle: "Cancel granted subscription",
    cancelBody: "Coverage stops immediately. A cancellation cannot be undone.",
    actionReason: "Reason (required)",
    done: "Done",
  },
};

export const grantText = (lang) => GRANT_TEXT[lang === "ar" ? "ar" : "en"];

/**
 * What kind of subscription a ledger block is showing, for the origin tag: one of
 * `pending_payment | granted | pending_start | expired | paid | converted | null`.
 */
export const originTagOf = (block, now = new Date()) => {
  const current = block?.currentSubscription;
  if (current?.origin === "admin_grant") {
    const grant = current.grant || {};
    if (grant.expiredAt || (grant.endDate && new Date(grant.endDate) < now)) return "expired";
    if (grant.startDate && new Date(grant.startDate) > now) return "pending_start";
    return "granted";
  }
  if (current) {
    if (current.grant?.conversionPending) return current.grant.endDate && new Date(current.grant.endDate) < now ? "expired" : "converting";
    return current.grant?.convertedAt ? "converted" : "paid";
  }
  if (block?.pendingSubscription) return "pending_payment";
  const last = (block?.history || [])[0];
  if (last?.grant && last.status === "canceled" && (last.grant.expiredAt || last.origin === "admin_grant")) return "expired";
  return null;
};
